import * as yup from 'yup';

const createLotSchema = yup.object({
  estate_id: yup.string().required('Estate is required'),
  varietal: yup.string().required('Varietal is required'),
  weight_of_coffee: yup
    .number()
    .transform(value => (value === '' ? undefined : value))
    .typeError('Enter a valid number')
    .test('max-2-decimals', 'Use at most two decimals', value => value === undefined || Number.isInteger(value * 100))
    .required('Weight is required'),
  date_of_harvest: yup.date().nullable().required('Harvest date is required'),
  date_of_sourcing: yup.date().nullable().required('Sourcing date is required'),
});

export default createLotSchema;
